import { Spinner } from "@narmi/design_system";
import { type VinLookupStatus } from "./useVinLookup";
import styles from "./VinStatusIndicator.module.css";

interface VinStatusIndicatorProps {
  status: VinLookupStatus;
  /** Current VIN input length, for the character counter. */
  vinLength: number;
}

/**
 * The status slot inside the VIN input: a character counter while typing (and
 * on a failed lookup), a spinner while decoding, a check on a match.
 */
function VinStatusIndicator({ status, vinLength }: VinStatusIndicatorProps) {
  if (status === "decoding") {
    // The NDS Spinner's default color is white, which is invisible on the
    // input's white background.
    return <Spinner size={24} color="var(--font-color-hint)" />;
  }

  if (status === "matched") {
    return (
      <span className={styles.successIcon} data-testid="vin-decode-success">
        <i className="narmi-icon-check" />
      </span>
    );
  }

  return (
    <span className={styles.counter}>
      {vinLength}
      /17
    </span>
  );
}

export { VinStatusIndicator };
